export const TOPTENLIST_IS_PUBLIC_VALUES = [false, true];
export const MAX_TOPTENITEMS_IN_TOPTENLIST = 10;
export const PAGE_SIZE = 10;
export const COLORS = { // svg icon colors need to be in code not css
	'USETEXT': '#666',
	'TOPTENITEM': '#028fcc',
	'TOPTENLIST': '#028fcc',
	'REUSABLEITEM': '#6db65b',
	'HELP': '#666',
	'BUTTONSECONDARY': '#fff',
	'BUTTONNOTIFICATIONS': 'rgba(255,255,255,.5)',
	'REGULARTEXT': '#666',
	'SECONDARYTEXT': '#999',
};
